import React from "react";
import { Alert, Space } from "antd";

import StatCards from "./StatCards";
import RecentActivities from "./RecentActivities";
import useMyTransactions, { formatTotals, isInProgress, isPaid, transactionAmount } from "../../../hooks/useMyTransactions";
import useCurrency from "../../../hooks/useCurrency";

/** Synthèse : ventes, achats, gains reçus, transactions en cours et dernières activités. */
const Overview = () => {
    const { transactions, sales, purchases, loading, error, userId } = useMyTransactions();
    const { currency } = useCurrency();

    const stats = [
        { title: "Ventes", value: sales.length },
        { title: "Achats", value: purchases.length },
        { title: "Gains reçus", value: formatTotals(sales.filter(isPaid), transactionAmount, currency) },
        { title: "Transactions en cours", value: transactions.filter(isInProgress).length }
    ];

    return (
        <Space orientation="vertical" size={20} style={{ width: "100%" }}>
            {error && <Alert type="warning" showIcon title="Impossible de charger votre activité pour le moment." />}
            <StatCards stats={stats} loading={loading} />
            <RecentActivities
                title="Activités récentes"
                transactions={transactions}
                loading={loading}
                userId={userId}
                limit={5}
            />
        </Space>
    );
};

export default Overview;
